/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum DescriptionAttributeForChangeManagementForCostRecommendation {
    action_name = 'action_name',
    classification = 'classification',
    current_sku = 'current_sku',
    impact = 'impact',
    optimization_type = 'optimization_type',
    project_name = 'project_name',
    recommendation_id = 'recommendation_id',
    recommended_sku = 'recommended_sku',
    resource_id = 'resource_id',
    resource_name = 'resource_name',
    service_account_name = 'service_account_name',
    sub_classification = 'sub_classification'
}
